import * as ROLES from './roles';

const authenticatedUserCondition = (authUser) => !!authUser;
const adminUserCondition = (authUser) => authUser && !!authUser.roles[ROLES.ADMIN];

export { authenticatedUserCondition, adminUserCondition };
